export default function CComparisonOperators() {
  return <h2>C Comparison Operators</h2>;
}
